export default __webpack_public_path__ + "static/media/btn-google-play.194cc0b8.png";